import React from 'react';
import Auth0ProviderWrapper from './Auth0ProviderWrapper';
import Auth0Login from './Auth0Login';

const Auth0LoginPage = () => {
    return <Auth0Login />;
};

export default Auth0LoginPage;
